import styled from "styled-components";

interface IInputElement {
  hasError?: any;
  disableOutline?: any;
  height?: string;
  width?: string;
}
export const InputElement = styled.input<IInputElement>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "4.5rem"};
    outline: ${props.disableOutline ? "none" : ""};
    width: ${props.width};
  `}

  box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  border-radius: 0.8rem;
  font-size: 1.5rem;
  font-weight: 500;
  padding-left: 1.5rem;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;
